import React from "react";
import CourierSupport from "../../../components/CourierSupport";

const CourierSupportForm = (props) => {
  return <CourierSupport {...props} />;
};

export default CourierSupportForm;
